import { render } from "./ParticipantsInput.vue?vue&type=template&id=22102f0a"
import script from "./ParticipantsInput.vue?vue&type=script&lang=js"
export * from "./ParticipantsInput.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "22102f0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22102f0a', script)) {
    api.reload('22102f0a', script)
  }
  
  module.hot.accept("./ParticipantsInput.vue?vue&type=template&id=22102f0a", () => {
    api.rerender('22102f0a', render)
  })

}

script.__file = "src/components/ParticipantsInput.vue"

export default script